import { get, post, put, destroy } from "./messageClient";

const messagingService = {
  registerDeviceToken: (body) => post(`/api/device/`, body),
  login: (body) => post(`/auth`, body),
  getChatMessages: (groupId, lastMessageId, count, previous, filters) =>
    get(
      `/api/messagingGroup/` +
        groupId +
        `/message?count=` +
        count +
        (lastMessageId ? `&lastMessageId=` + lastMessageId : "") +
        `&previous=` +
        previous +
        `&filters=` +
        filters
    ),
  getPresenceStatus: (userId) => get(`/api/user/` + userId + `/presence`),
  setPresenceStatus: (body) => post(`/api/user/presence`, body),

  //Messaging
  sendMessage: (groupId, body) =>
    post(`/api/messaging/group/` + groupId + `/message`, body),
  deleteMessage: (groupId, messageId) =>
    destroy(`/api/messaging/group/` + groupId + `/message/` + messageId),
  sendAck: (groupId, messageId, body) =>
    put(`/api/messaging/group/` + groupId + `/message/` + messageId, body),
  markAsSeen: (groupId, messageId, body) =>
    put(`/api/messaging/group/` + groupId + `/message/` + messageId, body),
  starredMessage: (groupId, messageId) =>
    post(
      `/api/messaging/group/` + groupId + `/message/` + messageId + `/starred`
    ),

  //Messaging Group
  createGroup: (body) => post(`/api/messagingGroup`, body),
  findGroup: (groupId) => get(`/api/messagingGroup/` + groupId),
  getChats: () => get(`/api/messagingGroup/list`),
  pinGroup: (groupId) => get(`/api/messagingGroup/pinGroup/` + groupId),
  deleteGroup: (groupId) => destroy(`/api/messagingGroup/` + groupId),
  editGroup: (groupId, body) => put(`/api/messagingGroup/` + groupId, body),
  archiveGroup: (groupId) =>
    post(`/api/messagingGroup/` + groupId + `/archive`),
  getLastChats: () => get(`/api/messagingGroup/getLast`),
  addParticipantToGroup: (groupId, body) =>
    post(`/api/messagingGroup/` + groupId + `/participant`, body),
  deleteParticipantFromGroup: (groupId, body) =>
    destroy(`/api/messagingGroup/` + groupId + `/participant`, { data: body }),
  leaveGroup: (groupId) => destroy(`/api/messagingGroup/` + groupId + `/leave`),
  addAdminRights: (groupId, body) =>
    post(`/api/messagingGroup/` + groupId + `/admin`, body),
  removeAdminRights: (groupId, body) =>
    destroy(`/api/messagingGroup/` + groupId + `/admin`, { data: body }),

  //Call
  makeCall: (groupId, body) =>
    post(`/api/messagingGroup/` + groupId + `/call`, body),
  answerCall: (groupId, roomId, body) =>
    post(`/api/messagingGroup/` + groupId + `/call/answer/` + roomId, body),
  rejectCall: (groupId, roomId, body) =>
    destroy(`/api/messagingGroup/` + groupId + `/call/` + roomId, {
      data: body,
    }),
  endCall: (groupId, roomId) =>
    put(`/api/messagingGroup/` + groupId + `/call/` + roomId),
  markBusyCall: (groupId, roomId, body) =>
    put(`/api/messagingGroup/` + groupId + `/call/` + roomId + `/busy`, body),
  markNoAnswerCall: (groupId, roomId, body) =>
    put(
      `/api/messagingGroup/` + groupId + `/call/` + roomId + `/noAnswer`,
      body
    ),
};

export default messagingService;
